import { connect } from "react-redux";
import Risk from "./Risk";
import {
  getRisk,
  createRiskRequest,
  updateRiskRequest,
  deleteRiskRequest,
} from "../../store/actions/risks.actions";
import {
  risks,
  riskLoading,
  riskStatusLoading,
  riskPagination,
  getError,
} from "../../store/selectors/risks.selector";
const mapDispatchToProps = {
  getRiskRequest: getRisk,
  createRiskRequest,
  updateRiskRequest,
  deleteRiskRequest,
};

const mapStateToProps = (state) => {
  const allRisks = risks(state);
  const loading = riskStatusLoading(state);
  const pageLoading = riskLoading(state);
  const pagination = riskPagination(state);
  const error = getError(state);
  return { allRisks, loading, pageLoading, pagination, error };
};

export default connect(mapStateToProps, mapDispatchToProps)(Risk);
